import React from 'react'
import { useCallback } from 'sb-hooks'

import { Box } from 'components/_new/layout'
import Checkbox from 'components/forms/Checkbox/Checkbox'

import s from './Contact.scss'


type ContactProps = {
  name: string
  email: string
  isActive: boolean
  index: number
  onChange?: (index: number) => void
}


const Contact: React.FunctionComponent<ContactProps> = (props) => {
  const { name, email, isActive, index, onChange } = props

  const handleChange = useCallback(() => {
    onChange(index)
  }, [ onChange, index ])

  return (
    <Box
      className={s.contact}
      pt={8}
      pb={8}
      pr={8}
    >
      <div>
        <Checkbox
          checked={isActive}
          onChange={handleChange}
        >
          {name}
        </Checkbox>
      </div>
      <div className={s.email}>{email}</div>
    </Box>
  )
}


export default React.memo(Contact)
